import React, { useEffect, useState } from 'react';
import * as THREE from 'three';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
//import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
//import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';

import { MyMTLLoader } from '../threejs_overrides/MyMTLLoader';

import EpicSpinner from './EpicSpinner';

import { HTTP } from '../services/httpSvc';
import { MyOBJLoader } from '../threejs_overrides/MyOBJLoader';

function renderObjWithSkin(model, done) {
  const canvas = document.querySelector('#c');
  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true });
  renderer.setClearColor(0x000000, 0);

  const fov = 40;
  const aspect = 2; // the canvas default
  const near = 1;
  const far = 100;
  const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
  camera.position.set(0, 4, 0);

  const controls = new OrbitControls(camera, canvas);
  controls.minPolarAngle = Math.PI / 2;
  controls.maxPolarAngle = Math.PI / 2;
  controls.enableZoom = false;
  controls.update();

  const scene = new THREE.Scene();

  function addAmbientLight() {
    const intensity = 0.2;
    const light = new THREE.AmbientLight('#fff', intensity);
    scene.add(light);
  }

  function addHemisphericalLight() {
    const skyColor = '#b1e1ff';
    const groundColor = '#b97a20';
    const intensity = 1;
    const light = new THREE.HemisphereLight(skyColor, groundColor, intensity);
    scene.add(light);
  }

  function addDirectionalLight() {
    const color = '#fff';
    const intensity = 1;
    const light = new THREE.DirectionalLight(color, intensity);
    light.position.set(0, 10, 0);
    light.target.position.set(-5, 0, 0);
    scene.add(light);
    scene.add(light.target);
  }



  function ObjLoader() {
    const o = new MyOBJLoader();
    o.setRequestHeader({ Authorization: `Bearer ${model.token}` });
    return o
  }

  function MtlLoader() {
    const m = new MyMTLLoader()
    m.setRequestHeader({ Authorization: `Bearer ${model.token}` });
    return m
  }

  function loadObj() {
    const mtlLoader = MtlLoader();
    mtlLoader.load(model.mtl, (mtl) => {
      const objLoader = ObjLoader()
      mtl.preload();
      objLoader.setMaterials(mtl);
      objLoader.load(model.obj, (root) => {
        console.log('obj loaded', root);
        scene.add(root);

        done && done();
      });
    }, (event) => console.log(event), (err) => {
      console.error(err)
      const o = ObjLoader()
      objLoader.load(model.obj, (root) => {
        console.log('obj loaded', root);
        scene.add(root);

        done && done();
      });
    });
  }

  function resizeRendererToDisplaySize(renderer) {
    const canvas = renderer.domElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const needResize = canvas.width !== width || canvas.height !== height;
    if (needResize) {
      renderer.setSize(width, height, false);
    }
    return needResize;
  }

  function render() {
    if (resizeRendererToDisplaySize(renderer)) {
      const canvas = renderer.domElement;
      camera.aspect = canvas.clientWidth / canvas.clientHeight;
      camera.updateProjectionMatrix();
    }

    renderer.render(scene, camera);

    requestAnimationFrame(render);
  }


  addDirectionalLight();
  addAmbientLight();
  addHemisphericalLight();
  loadObj();
  requestAnimationFrame(render);
}

const ThreejsObjViewer = ({ model }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const cb = () => setLoading(false);
    setTimeout(() => renderObjWithSkin(model, cb));
  }, []);

  return (
    <div>
      <canvas id="c" style={{ height: '100%', width: '100%' }} />
      {loading ? <EpicSpinner noBg={true} /> : []}
    </div>
  );
};

export default ThreejsObjViewer;
